export const platforms = [
    {
        logo: "/layer_zero_logo.jpeg",
        networkLogo: "https://raw.githubusercontent.com/faisalsaleemdev/storage/main/clutch.jpeg",
        name: "Smoove Bridge",
        link: "/"
    }
];